import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";

import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Nullable } from "primereact/ts-helpers.js";
import { DropDownList, StepCallBack } from "@modules/plaintes/plaintes.model.ts";
import {
  CommuneDTO,
  FokontanyDTO,
} from "@utils/appUtils.ts";
import { useAppDispatch, useAppSelector } from "@core/store/hook.ts";
import { dataUser } from "@core/slice/UsersSlice.ts";
import { sectorStepOne, setSector, setSelectedStatus, setStepReasonValue, stepReasonValue } from "@core/slice/ComplaintSlice.ts";

const GeneralInfos: React.FC<StepCallBack> = ({
  onNext,
  isResolvedComplaint,
}) => {
  const dispatch = useAppDispatch();
  const stepReason = useAppSelector(stepReasonValue);
  const sector = useAppSelector(sectorStepOne)
  const storedUserInfos = useAppSelector(dataUser);
  const [date, setDate] = useState<Nullable<Date>>(null);
  const [fokontany, setFokontany] = useState<FokontanyDTO>();
  const [commune, setCommune] = useState<CommuneDTO>();
  const [district, setDistrict] = useState<any>();
  const [region, setRegion] = useState<any>();

  React.useEffect(() => {
    if (stepReason?.stepFive === undefined) {
      dispatch(setSelectedStatus({} as DropDownList));
    }
    //eslint-disable-next-line
  }, []);

  function handleNextStep() {
    if (isResolvedComplaint) {
      if (commune && date && district && fokontany && region) {
        dispatch(
          setStepReasonValue({
            stepOne: {
              commune,
              date,
              district,
              fokotany: fokontany,
              region,
            },
            stepTwo: stepReason !== null ? stepReason.stepTwo : null,
            stepThree: stepReason !== null ? stepReason.stepThree : null,
            stepFour:
              stepReason !== null
                ? stepReason.stepFour
                : {
                    natureComplaintSelectedList: [],
                    subNatureComplaintSelectedList: [],
                    complaintSubNatures: []
                  },
            stepFive: stepReason !== null ? stepReason.stepFive : null,
            victimStep: stepReason !== null ? stepReason.victimStep : null,
            agressorStep: stepReason !== null ? stepReason.agressorStep : null,
          })
        );
      }
    }
    onNext();
  }
// console.log("null", storedUserInfos);
  useEffect(() => {
    setDate(new Date());
    if (storedUserInfos) {
      setFokontany(storedUserInfos.fokontany);
      setCommune(storedUserInfos.fokontany.municipality);
      setDistrict(storedUserInfos.fokontany.municipality?.district);
      setRegion(storedUserInfos.fokontany.municipality?.district.region);
    }
  }, [storedUserInfos]);

  return (
    <div className="column gap-[20px] h-12rem card-stepper">
      <div className="stitle">Références de la plainte</div>
      <div className="grid grid-cols-1 gap-5 ">
        <div className="flex flex-wrap gap-3">
          <div className="flex-auto column gap-2 w-full">
            <label htmlFor="date">Date de la plainte / signalement</label>
            <Calendar
                placeholder="dd/mm/yyyy"
                id="buttondisplay"
                value={date}
                onChange={(e) => setDate(e.value)}
                showIcon
                dateFormat="dd/mm/yy"
                disabled
              />

          </div>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5 ">
        {!isResolvedComplaint && (
          <div className="flex flex-wrap gap-3">
            <div className="column gap-2 w-full">
              <label htmlFor="username">Organisation</label>
              <InputText
                id="username"
                placeholder="Organisation"
                aria-describedby="username-help"
                value={
                  storedUserInfos && storedUserInfos.profil.accesses
                    ? storedUserInfos.profil.accesses
                        .map((e:any) => e.description)
                        .join(", ")
                    : ""
                }
                disabled
              />
            </div>
          </div>
        )}
        <div className="flex flex-wrap gap-3">
          <div className="column gap-2 w-full">
            <label htmlFor="username">Région</label>
            <InputText
              id="username"
              placeholder="Région"
              aria-describedby="username-help"
              value={region?.name ?? ""}
              disabled
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <div className="column gap-2 w-full">
            <label htmlFor="username">District</label>
            <InputText
              id="district"
              placeholder="District"
              value={district?.name ?? ""}
              disabled
            />
          </div>
        </div>

        <div className="flex flex-wrap gap-3">
          <div className="column gap-2 w-full">
            <label htmlFor="username">Commune</label>
            <InputText
              id="commune"
              placeholder="Commune"
              value={commune?.name ?? ""}
              disabled
            />
          </div>
        </div>

        {/*
        <div className="flex flex-wrap gap-3">
          <div className="column gap-2 w-full">
            <label htmlFor="username">Fokontany</label>
            <InputText
              id="fkt"
              placeholder="Fokontany"
              value={fokontany?.name ?? ""}
              disabled
            />
          </div>
        </div>
        */}
        {!isResolvedComplaint && (
          <div className="flex flex-wrap gap-3">
            <div className="column gap-2 w-full">
              <label htmlFor="username">Secteur</label>
              <InputText id="fkt" placeholder="Secteur" value={sector} onChange={(e)=>dispatch(setSector(e.target.value))} maxLength={255}/>
            </div>
          </div>
        )}
      </div>
      <div className="flex pt-4 justify-content-end">
        <Button
          label="Suivant"
          className="btn btn-primary w-[120px]"
          onClick={handleNextStep}
        />
      </div>
    </div>
  );
};

export default GeneralInfos;
